import React from 'react';
import PropTypes from 'prop-types';
import {COMPONENT_TYPE} from '@learningblocks/exp-constants/lib/Utilities';
import './style.scss';
import parse from 'html-react-parser';

const INPUT_TYPES = {
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
};
const CLASSNAMES = {
  CORRECT: 'correct',
  INCORRECT: 'incorrect',
};

export class AnswerChoice extends React.Component {
  renderFeedback() {
    if (this.props.disabled && this.props.feedback !== "") {
      return (
        <p
          className={
            this.props.isCorrect ? CLASSNAMES.CORRECT : CLASSNAMES.INCORRECT
          }>
          {parse(this.props.feedback)}
        </p>
      );
    } else {
      return null;
    }
  }
  selectOption = (event) => {
    event.stopPropagation();
    if (this.props.disabled === false) {
      let payload = {
        componentID: this.props.componentID,
        optionID: this.props.id,
        optionGroup: this.props.optionGroup,
        checked: !this.props.selected,
        key: this.props.answerKey,
        disabled: this.props.disabled?false:null,
        reset: (this.props.answerId == -1)
      };
      if (
        this.props.componentType === COMPONENT_TYPE.CSCQ ||
        this.props.componentType === COMPONENT_TYPE.GROUPED_CSCQ ||
        this.props.componentType === COMPONENT_TYPE.CSCQ_COLOR
      ) {
        this.props.selectOption(payload);
      }
      if (this.props.componentType === COMPONENT_TYPE.MSCQ) {
        this.props.selectCheckbox(payload);
      }
    }
  };

  wrapperClass() {
    const classList = [this.props.className, 'choice'];
    if (this.props.disabled && this.props.selected) {
      if (this.props.isCorrect) classList.push(CLASSNAMES.CORRECT);
      else classList.push(CLASSNAMES.INCORRECT);
    }
    return classList.join(' ');
  }

  getInputType() {
    if (
      this.props.componentType === COMPONENT_TYPE.CSCQ ||
      this.props.componentType === COMPONENT_TYPE.GROUPED_CSCQ ||
      this.props.componentType === COMPONENT_TYPE.CSCQ_COLOR
    ) {
      return INPUT_TYPES.RADIO;
    } else {
      return INPUT_TYPES.CHECKBOX;
    }
  }

  isDisabled = () => {
    return (this.getInputType() === "checkbox" && !this.props.isCorrect && this.props.disabled)?false:this.props.disabled
  }

  render() {
    return (
      <>
        <div tabIndex={0} className={this.wrapperClass()} onClick={this.selectOption} onKeyDown={ (e)=>{if(e.keyCode === 13 || e.keyCode === 32) this.selectOption(e)} }>
          <input
            type={this.getInputType()}
            id={this.props.text}
            value={this.props.id}
            checked={this.props.selected}
            disabled={this.isDisabled()}
            readOnly
          />
          <label
            className="response"
            htmlFor={this.props.text}
            aria-label={((this.props.checked)?"selected, ":"") + ((this.props.isCorrect !== null)?((this.props.isCorrect === true)?"correct, ":"incorrect, "):"") + String.fromCharCode(97 + this.props.id)+", "+this.props.text}
            >
            <span aria-hidden="true" className="checkmark">{String.fromCharCode(97 + this.props.id).toUpperCase()}</span>
            <div style={{display: "inline"}}>{parse(this.props.text)}</div>
          </label>
        </div>
        {this.renderFeedback()}
      </>
    );
  }
}
AnswerChoice.propTypes = {
  className: PropTypes.string,
  componentID: PropTypes.number,
  feedback: PropTypes.string,
  id: PropTypes.number,
  isCorrect: PropTypes.bool,
  selected: PropTypes.bool,
  text: PropTypes.string,
  disabled: PropTypes.bool,
  selectOption: PropTypes.func,
  selectCheckbox: PropTypes.func,
};
